/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BankAccountPayment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import PaymentProviderMethod from 'DesignSystem/PaymentProvider/PaymentProviderMethod/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function BankAccountPayment({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsPostPayment/Content/Content/Content/PaymentMethods/BankAccountPayment"
  
}) {
let globalCurrentLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location._id',
})
let paymentsPostPaymentPaymentAccountPayerPersonValueData = fromData.useDataValue({ viewPath,
context: 'payments_post_payment',
path: 'payment_account.payer_person',
})
let paymentsPostPaymentPaymentAccountAccountTypeValueData = fromData.useDataValue({ viewPath,
context: 'payments_post_payment',
path: 'payment_account.account_type',
})
  return (<React.Fragment
>
<PaymentProviderMethod
  viewPath={`${viewPath}/PaymentProviderMethod`}
 method="ach"
 data="global.current_location._id"
 locationId={globalCurrentLocationIdValueData}
 data="payments_post_payment.payment_account.payer_person"
 person={paymentsPostPaymentPaymentAccountPayerPersonValueData}
 data="payments_post_payment.payment_account.account_type"
 paymentAccountType={paymentsPostPaymentPaymentAccountAccountTypeValueData}
/>
{children}
</React.Fragment>)
}